/**
 * Global Lenis Smooth Scrolling Initialization
 * Syncs with GSAP if available, handles Shopify Theme Editor events, and respects reduced motion.
 */
(function() {
  if (typeof window.Lenis === 'undefined') return;

  // Singleton instance
  let lenis = null;

  function initLenis() {
    // Accessibility: Respect user's system preferences for reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      if (lenis) {
        lenis.destroy();
        lenis = null;
      }
      return;
    }

    // Destroy existing instance to prevent duplicates
    if (lenis) lenis.destroy();

    // Initialize premium smooth scroll
    lenis = new window.Lenis({
      duration: 1.2,
      easing: (t) => 1 - Math.pow(1 - t, 4), // Quartic ease out for buttery smooth feel
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      smoothTouch: false, // Keep native touch scrolling for responsiveness on mobile
      touchMultiplier: 2,
    });

    // Safely sync with ScrollTrigger if it exists
    lenis.on('scroll', () => {
      if (window.ScrollTrigger) {
        window.ScrollTrigger.update();
      }
    });

    // Use standard requestAnimationFrame instead of GSAP ticker to avoid time calculation crashes
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Handle anchor links for smooth scrolling to sections
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        // Ignore empty hashes or skip-to-content links
        if (targetId === '#' || targetId === '#MainContent') return;
        
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          // Adjust offset based on Shopify header height variable
          let offset = -100;
          const headerHeight = document.body.style.getPropertyValue('--header-height');
          if (headerHeight) {
            offset = -(parseInt(headerHeight.replace('px', '')) || 100);
          }
          lenis.scrollTo(targetElement, { offset: offset });
        }
      });
    });

    // Expose lenis globally for other scripts if needed
    window.globalLenis = lenis;
  }

  // Initialize on script load
  initLenis();

  // Shopify Theme Editor Integration
  document.addEventListener('shopify:section:load', () => {
    if (lenis) {
      lenis.resize();
    }
  });

  document.addEventListener('shopify:section:unload', () => {
    if (lenis) {
      lenis.resize();
    }
  });

})();
